/** Schritt 7 „Prüfen & starten“. */
const wizReviewDE = {
  wizRevKeyJob: 'Stelle',
  wizRevCampaignName: 'Kampagne „{{name}}“',
  wizRevKeyCandidates: 'Kandidaten',
  wizRevKeyBlacklist: 'Blacklist',
  wizRevKeyJudging: 'KI-Bewertung',
  wizRevKeyList: 'Kandidatenliste',
  wizRevKeyApproach: 'Ansprache',
  wizRevKeyMessages: 'Nachrichten',
  wizRevEdit: 'Bearbeiten',
  wizRevSaiaSearch: 'SAIA-Suche',
  wizRevOwnSearch: 'Eigene LinkedIn-Suche',
  wizRevOwnSearches_one: '{{count}} eigene LinkedIn-Suche',
  wizRevOwnSearches_other: '{{count}} eigene LinkedIn-Suchen',
  wizRevProfiles: 'ca. {{count}} Profile',
  wizRevNoLocation: 'kein Ort',
  wizRevLocationUnconfirmed: '{{city}} (bitte bestätigen)',
  wizRevLocationWholeRegion: '{{city}} (ganze Region)',
  wizRevListWithPast: '{{name}} (auch frühere Arbeitgeber)',
  wizRevNoBlacklist:
    'Keine Blacklist aktiv – bereits bekannte Firmen und Kontakte werden nicht ausgeschlossen.',
  wizRevBlacklistEntries: '{{count}} Einträge für diese Kampagne',
  wizRevModified: '(angepasst)',
  wizRevJudgingSkipped: 'Ohne KI-Bewertung – alle Kandidaten werden angesprochen',
  wizRevClass: 'Klasse {{classes}}',
  wizRevNoClass: 'keine',
  wizRevListValue: '{{active}} von {{total}} Kandidaten der Vorschau aktiv · weitere laufend',
  wizRevListPending: 'Die ersten Kandidaten werden noch geladen',
  wizRevListDone: '{{active}} von {{total}} Kandidaten der Vorschau aktiv',
  wizRevListNone: 'Keine Treffer gefunden',
  wizRevListNotStarted: 'Die Suche wurde noch nicht gestartet',
  wizRevListFailed: 'Die Suche ist fehlgeschlagen',
  wizRevFlow: 'Dynamischer Ablauf · {{count}} Nachrichten',
  wizRevFlowInmails: ', davon {{count}} InMails',
  wizRevFlowByReaction: 'je nach Reaktion',
  wizRevFlowPending: 'Dynamischer Ablauf · wird berechnet',
  wizRevRecruitsClients: 'Als Dienstleister',
  wizRevAudienceBoth: 'Neue + bestehende',
  wizRevNoteWith: 'Anfrage mit Nachricht',
  wizRevNoteWithout: 'Anfrage ohne Nachricht',
  wizRevReferral: 'Empfehlung {{bonus}}',
  wizRevLangAuto: 'Sprache automatisch',
  wizRevAgentTitle: 'So arbeitet der Agent',
  wizRevAgentSubtitle: 'Bewährte Standardwerte. Nur ändern, wenn du einen Grund hast.',
  wizRevChange: 'Ändern',
  wizRevDone: 'Fertig',
  wizRevSettingAccount: 'Absender',
  wizRevSettingWorkTime: 'Arbeitszeiten',
  wizRevSettingApprove: 'Freigabe',
  wizRevSettingRecontact: 'Bereits Kontaktierte',
  wizRevWorkTime0: 'Mo–Fr, 8–18 Uhr',
  wizRevWorkTime1: 'Mo–Fr, 9–17 Uhr',
  wizRevWorkTime2: 'Mo–Sa, 8–20 Uhr',
  wizRevWorkTime3: 'Arbeitszeiten des LinkedIn-Kontos',
  wizRevWorkTimeAccountSuffix: '(wie im Konto)',
  wizRevChoose: 'Bitte auswählen',
  wizRevApproveHint0: 'Du findest die freizugebenden Nachrichten unter „Aufgaben verwalten“.',
  wizRevApproveHint1:
    'SAIA erstellt und versendet Deine Nachrichten 1:1 entsprechend Deinem gespeicherten Nachrichten-Ablauf.',
  wizRevRecontactHint:
    'Dies beinhaltet alle Kandidaten, welche du selber über InMail oder Chat angeschrieben hast, sowie Kandidaten aus anderen SAIA-Kampagnen.',
  wizRevWorkWindow: '{{days}}, {{hours}} Uhr',
  wizRevWorkWindowNone: 'Kein gemeinsames Fenster mit dem Konto – es wird nichts gesendet',
  wizRevAnd: 'und',
  wizRevDayMo: 'Mo',
  wizRevDayTu: 'Di',
  wizRevDayWe: 'Mi',
  wizRevDayTh: 'Do',
  wizRevDayFr: 'Fr',
  wizRevDaySa: 'Sa',
  wizRevDaySu: 'So',
  wizRevApprove0: 'Jede Nachricht vorher freigeben',
  wizRevApprove1: 'Nachrichten automatisch senden',
  wizRevSettingApproveContacts: 'Kontakte',
  wizRevApproveContacts0: 'Jeden Kontakt vor der Ansprache freigeben',
  wizRevApproveContacts1: 'Bewertete Kontakte direkt ansprechen',
  wizRevRecontactNone: 'Keine Einschränkung',
  wizRevRecontactNever: 'Nie erneut ansprechen',
  wizRevRecontact14: 'Nach 2 Wochen',
  wizRevRecontact28: 'Nach 4 Wochen',
  wizRevRecontact60: 'Nach 2 Monaten',
  wizRevRecontact90: 'Nach 3 Monaten',
  wizRevRecontact180: 'Nach 6 Monaten',
  wizRevRecontactDays: 'Nach {{days}} Tagen',
  wizRevKeyAutoReply: 'Auto-Antworten',
  wizRevAutoReplyOn: 'An · {{count}} Fälle',
  wizRevAutoReplyOff: 'Aus',
  wizRevFormalSie: 'Sie-Form',
  wizRevFormalDu: 'Du-Form',
};
export default wizReviewDE;
